import { useAppState } from "@/modules/app/useAppContext";
import { Groups as GroupsLegacy } from "../Groups";
import Groups from "./Groups";

const GroupsWrapper = () => {
  const { enableCustomWorkloadsChartAggregation } = useAppState();

  if (enableCustomWorkloadsChartAggregation) {
    return <Groups />;
  }

  return <GroupsLegacy />;
};

export default GroupsWrapper;
